/**
 * ParticleEffect.js
 *
 * This file contains a React component that uses the tsparticles library to create a particle effect.
 *
 */

import { useEffect, useState } from "react";

import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFull } from "tsparticles";

import "./ParticleEffect.css";

const ParticleEffect = () => {
	const [init, setInit] = useState(false);

	// load the particle effect when the component is mounted
	useEffect(() => {
		initParticlesEngine(async (engine) => {
			await loadFull(engine);
		}).then(() => {
			setInit(true);
		});
	}, []);

	const particlesLoaded = (container) => {
		console.log(container);
	};

	const particlesOptions = {
		background: {
			color: {
				value: "rgb(0, 53, 107)",
			},
		},
		fpsLimit: 120,
		interactivity: {
			events: {
				onHover: {
					enable: false,
					mode: "repulse",
				},
				resize: true,
			},
		},
		particles: {
			color: {
				value: "#fff",
			},
			links: {
				color: "#ffffff",
				distance: 150,
				enable: true,
				opacity: 0.5,
				width: 1,
			},
			move: {
				enable: true,
				speed: 2,
			},
			number: {
				density: {
					enable: true,
					area: 120,
				},
				value: 130,
			},
			opacity: {
				value: 1,
			},
			shape: {
				type: "polygon",
				polygon: {
					nb_sides: 5,
				},
				stroke: {
					width: 0,
					color: "#ff0000",
				},
			},
			size: {
				value: { min: 2, max: 4 },
			},
		},
		detectRetina: true,
	};

	return (
		init && (
			<Particles
				id="tsparticles"
				particlesLoaded={particlesLoaded}
				options={particlesOptions}
			/>
		)
	);
};

export default ParticleEffect;
